<template>
  <div class="candidate-tabs-panel fill-height pr-md-2">
    <VTabs
      v-model="activeTabIndex"
      background-color="transparent"
      color="dark"
      slider-size="4"
      slider-color="primary"
      :grow="$vuetify.breakpoint.smAndDown"
      :show-arrows="false"
      class="candidate-tabs-panel__tabs fill-height pt-md-4"
    >
      <VTab
        class="mr-6 ml-1 ml-md-4"
        :class="{ title: $vuetify.breakpoint.mdAndUp, 'subtitle-2': $vuetify.breakpoint.smAndDown }"
        :ripple="false"
      >
        {{ $t('events') }}
      </VTab>
      <VTab
        v-if="showQuestionsTab"
        class="mr-6"
        :class="{ title: $vuetify.breakpoint.mdAndUp, 'subtitle-2': $vuetify.breakpoint.smAndDown }"
        :ripple="false"
      >
        {{ $t('questions') }}
      </VTab>
      <VTab
        v-if="candidate.testFinishedAt"
        class="mr-6"
        :class="{ title: $vuetify.breakpoint.mdAndUp, 'subtitle-2': $vuetify.breakpoint.smAndDown }"
        :ripple="false"
      >
        {{ $t('testing') }}
      </VTab>
      <VTabItem>
        <CandidateLog
          :vacancy="vacancy"
          :candidate="candidate"
          :show-review="showReview"
          @show-interview="$emit('show-interview', $event)"
          @change-active-tab="changeActiveTab($event)"
        />
      </VTabItem>
      <VTabItem v-if="showQuestionsTab">
        <VacancyQuestionsList
          v-if="candidate.interview"
          v-model="activeQuestion"
          :vacancy="vacancy"
          :online-interview="candidate.interview"
          :are-questions-equal="areQuestionsEqual"
          @change-active-tab="changeActiveTab($event)"
        />
      </VTabItem>
      <VTabItem v-if="candidate.testFinishedAt">
        <CandidateTestResult
          :candidate="candidate"
        />
      </VTabItem>
    </VTabs>
  </div>
</template>

<script>
import CandidateLog from './CandidateLog.vue';
import VacancyQuestionsList from '../Vacancy/VacancyQuestionsList.vue';
import CandidateTestResult from './CandidateTestResult.vue';

export default {
  name: 'CandidateTabsPanel',
  components: {
    VacancyQuestionsList,
    CandidateLog,
    CandidateTestResult,
  },
  model: {
    prop: 'activeTab',
    event: 'input',
  },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    candidate: {
      type: Object,
      required: true,
    },
    showQuestionsTab: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Number,
      default: 0,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      showReview: false,
    };
  },
  computed: {
    activeTabIndex: {
      get() {
        return this.activeTab;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    activeQuestion: {
      get() {
        return this.question;
      },
      set(value) {
        this.$emit('updated:question', value);
      },
    },
  },
  methods: {
    changeActiveTab(tabId) {
      this.activeTabIndex = tabId;
      this.showReview = !this.showReview;
    },
  },
};
</script>

<style lang="scss" scoped>
.candidate-tabs-panel {
  &::v-deep * {
    box-sizing: border-box;
  }
}

.candidate-tabs-panel__tabs {
  &::v-deep {
    .v-tabs-bar--is-mobile {
      .v-slide-group__prev, .v-slide-group__next {
        display: none !important;
      }
    }

    .v-tabs-bar {
      margin-bottom: 0;
    }

    .v-tabs-items {
      height: calc(100% - 48px);

      .v-window__container {
        height: 100%;

        .v-window-item {
          height: 100%;
        }
      }

    }
  }
}

.v-tab::v-deep {
  font-size: 14px !important;
  @media screen and (max-width: 428px) {
    font-size: 10px !important;
  }
  @media screen and (max-width: 330px) {
    font-size: 9px !important;
  }
}
</style>

<i18n locale="en" lang="yaml">
  events: Events
  questions: Questions
  testing: Testing
</i18n>

<i18n locale="ru" lang="yaml">
  events: События
  questions: Вопросы
  testing: Тестирование
</i18n>
